import React from "react";
import { Card, FlexRow, TableWrap, SmallTable, SmallTh, SmallTd, BadgeDir, PrimaryButton, GhostButton } from "./styledComponents";

function IbanCard({ movements, onAction }) {
  return (
    <Card>
      <h3>EUR IBAN</h3>
      <p style={{ color: "#94a3b8", fontSize: 12, marginTop: 4 }}>
        Coordinate bancarie per on/off-ramp in EUR con supporto SEPA / SEPA Instant.
      </p>
      <FlexRow gap={16} style={{ marginTop: 10 }}>
        <div style={{ flex: 1, minWidth: 240 }}>
          <div
            style={{
              borderRadius: 12,
              border: "1px solid #1f2937",
              background: "#020617",
              padding: 10,
              fontSize: 12,
              lineHeight: 1.5,
            }}
          >
            <div>
              IBAN: <code>IT** **** **** **** **** **** ***</code>
            </div>
            <div>
              BIC: <code>****ITMMXXX</code>
            </div>
            <div>
              Intestato a: <code>PharmaCrowd Financial Services Ltd</code>
            </div>
            <div style={{ marginTop: 8 }}>
              Valute: <strong>EUR</strong> (SEPA / SEPA Instant) · supporto SWIFT multi-valuta in
              arrivo.
            </div>
          </div>
          <FlexRow gap={8} style={{ marginTop: 10 }}>
            <PrimaryButton onClick={() => onAction("Nuovo bonifico SEPA creato (demo)")}>
              New SEPA transfer
            </PrimaryButton>
            <GhostButton onClick={() => onAction("IBAN copiato negli appunti (demo)")}>
              Copy IBAN
            </GhostButton>
          </FlexRow>
        </div>
        <div style={{ flex: 1, minWidth: 260 }}>
          <h4 style={{ fontSize: 13, marginBottom: 6 }}>Movimenti IBAN</h4>
          <TableWrap>
            <SmallTable>
              <thead>
                <tr>
                  <SmallTh>Direzione</SmallTh>
                  <SmallTh align="right">Importo</SmallTh>
                  <SmallTh>Descrizione</SmallTh>
                  <SmallTh>Ref</SmallTh>
                  <SmallTh>Data/Ora</SmallTh>
                </tr>
              </thead>
              <tbody>
                {movements.map((m) => (
                  <tr key={m.ref}>
                    <SmallTd>
                      <BadgeDir direction={m.direction}>
                        {m.direction === "in" ? "Entrata" : "Uscita"}
                      </BadgeDir>
                    </SmallTd>
                    <SmallTd align="right">
                      {m.amount.toFixed(2)} {m.currency}
                    </SmallTd>
                    <SmallTd>{m.desc}</SmallTd>
                    <SmallTd style={{ fontFamily: "monospace" }}>{m.ref}</SmallTd>
                    <SmallTd>{m.ts}</SmallTd>
                  </tr>
                ))}
              </tbody>
            </SmallTable>
          </TableWrap>
        </div>
      </FlexRow>
    </Card>
  );
}

export default IbanCard;

